import { useCallback } from 'react';
import { useGetDisplayWebContentSelector } from './useGetDisplayWebContentSelector';

export const useGetControlGroupWeightSelector = () => {
  const getDisplayWebContent = useGetDisplayWebContentSelector();

  return useCallback((id: string) => getDisplayWebContent(id)?.controlGroupWeight, [getDisplayWebContent]);
};
